import api from './api';

const BASE = '/reportv2';

const buildPayload = (dateRange, extra = {}) => ({
  date_range: {
    start_date: dateRange.startDate,
    end_date: dateRange.endDate,
  },
  ...extra,
});

// ── Executive Dashboard ──────────────────────────────────────────────

export const fetchBusinessHealth = (dateRange, filters = {}) =>
  api.post(`${BASE}/executive/business-health/`, buildPayload(dateRange, filters));

export const fetchTeamsKPI = (dateRange, filters = {}) =>
  api.post(`${BASE}/executive/teams-kpi/`, buildPayload(dateRange, filters));

export const fetchAgentsKPI = (dateRange, filters = {}) =>
  api.post(`${BASE}/executive/agents-kpi/`, buildPayload(dateRange, filters));

// ── Conversation Intelligence ─────────────────────────────────────────

export const fetchCallAnalytics = (dateRange, filters = {}) =>
  api.post(`${BASE}/conversation/call-analytics/`, buildPayload(dateRange, filters));

export const fetchAICallInsights = (dateRange, filters = {}) =>
  api.post(`${BASE}/conversation/ai-call-insights/`, buildPayload(dateRange, filters));

export const fetchAgentScorecard = (_dateRange, filters = {}) =>
  api.post(`${BASE}/conversation/agent-scorecard/`, { ...filters });

// ── Pipeline Intelligence ──────────────────────────────────────────────

export const fetchLeadFunnel = (dateRange, filters = {}) =>
  api.post(`${BASE}/pipeline/lead-funnel/`, buildPayload(dateRange, filters));

export const fetchLeadTemperature = (dateRange, filters = {}) =>
  api.post(`${BASE}/pipeline/lead-temperature/`, buildPayload(dateRange, filters));

export const fetchLeadAging = (dateRange, filters = {}) =>
  api.post(`${BASE}/pipeline/lead-aging/`, buildPayload(dateRange, filters));

export const fetchNotInterestedRecovery = (dateRange, filters = {}) =>
  api.post(`${BASE}/pipeline/not-interested-recovery/`, buildPayload(dateRange, filters));

// ── Source & Channel Performance ────────────────────────────────────────

export const fetchSourceVisits = (dateRange, filters = {}) =>
  api.post(`${BASE}/source-channel/source-visits/`, buildPayload(dateRange, filters));

export const fetchSourceBookings = (dateRange, filters = {}) =>
  api.post(`${BASE}/source-channel/source-bookings/`, buildPayload(dateRange, filters));

export const fetchCPPerformance = (dateRange, filters = {}) =>
  api.post(`${BASE}/source-channel/cp-performance/`, buildPayload(dateRange, filters));

// ── Site Visit Intelligence ──────────────────────────────────────────

export const fetchSVOverall = (dateRange, filters = {}) =>
  api.post(`${BASE}/site-visit/overall/`, buildPayload(dateRange, filters));

export const fetchSVConversion = (dateRange, filters = {}) =>
  api.post(`${BASE}/site-visit/conversion/`, buildPayload(dateRange, filters));

export const fetchSVNoShowReschedule = (dateRange, filters = {}) =>
  api.post(`${BASE}/site-visit/noshow-reschedule/`, buildPayload(dateRange, filters));

export const fetchSVAgentEffectiveness = (dateRange, filters = {}) =>
  api.post(`${BASE}/site-visit/agent-effectiveness/`, buildPayload(dateRange, filters));

export const fetchSVSourceQuality = (dateRange, filters = {}) =>
  api.post(`${BASE}/site-visit/source-quality/`, buildPayload(dateRange, filters));

export const fetchSVProjectReport = (dateRange, filters = {}) =>
  api.post(`${BASE}/site-visit/project-report/`, buildPayload(dateRange, filters));
